import Form from "@Front/Components/DesignSystem/Form";
import TextField from "@Front/Components/DesignSystem/Form/TextField";
import Button from "@Front/Components/DesignSystem/Button";
import { ValidationError } from "class-validator";

type StepEmailFormProps = {
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	prefilledEmail: string;
	emailPlaceholder: string;
	submitCta: string;
	classes: Record<string, string>;
};

export default function StepEmailForm({
	onSubmit,
	validationErrors,
	prefilledEmail,
	emailPlaceholder,
	submitCta,
	classes,
}: StepEmailFormProps): React.JSX.Element {
	return (
		<Form className={classes["form"]} onSubmit={onSubmit}>
			<TextField
				placeholder={emailPlaceholder}
				name="email"
				defaultValue={prefilledEmail}
				validationError={validationErrors.find((err) => err.property === "email")}
			/>
			<Button type="submit">{submitCta}</Button>
		</Form>
	);
}
